import { Modal, Textarea } from '@cointracker/styleguide';
import { Button } from '@cointracker/styleguide/src/LoggedIn';
import { useEffect, useState } from 'react';

export function NotesModal({
  caseName,
  notes,
  isOpen,
  onDismiss,
  onSave,
}: {
  caseName: string;
  notes: string;
  isOpen: boolean;
  onDismiss: () => void;
  onSave: (notes: string) => void;
}) {
  const [notesValue, setNotesValue] = useState(notes || '');

  // Update state when prop changes
  useEffect(() => {
    if (isOpen) {
      setNotesValue(notes || '');
    }
  }, [notes, isOpen]);

  return (
    <Modal.Root open={isOpen} onOpenChange={(open) => !open && onDismiss()}>
      <Modal.Content className="min-w-[580px]">
        <Modal.ContentHeader title={`Notes for ${caseName}`} />
        <Modal.ContentBody>
          <Textarea
            inputClassName="resize-none h-[200px]"
            value={notesValue}
            onChange={(e) => setNotesValue(e.target.value)}
            placeholder="Add notes"
          />
        </Modal.ContentBody>
        <Modal.ContentFooter>
          <Button onClick={() => onSave(notesValue)}>Save</Button>
        </Modal.ContentFooter>
      </Modal.Content>
    </Modal.Root>
  );
}
